export default __webpack_public_path__ + "static/media/Product.92ad78a3.pdf";